import { NotificationText } from '@/data/context/notifications';

export const getNotificationTitle = (severity?: string, title?: NotificationText) => {
	if (title) {
		return title;
	}

	switch (severity) {
		case 'error':
			return 'Ocurrió un problema';
		case 'success':
			return '';
		default:
			return undefined;
	}
};
